import iziToast, { IziToastSettings } from 'izitoast';
import { APP_TRANSLATE } from 'src/app/app-translate';
import Swal, { SweetAlertOptions } from 'sweetalert2';

const defaultSettings: IziToastSettings = {
  position: 'topRight',
  timeout: 5000,
};

const translate = (key: string) => APP_TRANSLATE?.instant?.(key) ?? key;

export function alertSuccess(settings: IziToastSettings = {}) {
  return iziToast.success({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('SUCCESS'),
    message: ``,
    ...settings,
  });
}
export function alertWarning(settings: IziToastSettings = {}) {
  return iziToast.warning({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ALERT'),
    message: ``,
    ...settings,
  });
}
export function alertInfo(settings: IziToastSettings = {}) {
  return iziToast.info({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('DATA'),
    message: ``,
    ...settings,
  });
}
export function alertDanger(settings: IziToastSettings = {}) {
  return iziToast.error({
    ...defaultSettings,
    class: 'iziToast-fonts',
    title: translate('ERROR'),
    message: ``,
    ...settings,
  });
}

const defaultOptions: SweetAlertOptions = {
  icon: 'warning',
  showCancelButton: true,
  showConfirmButton: true,
  cancelButtonText: translate('CANCEL'),
  confirmButtonText: translate('CONFIRM'),
  reverseButtons: true,
  focusCancel: true,
  confirmButtonColor: 'var(--bs-primary)',
};
export function alertConfirm(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions,
    title: translate('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,

    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || translate('DO_YOU_WANT_TO_CONTINUE'),
      }
    ),
  });
}
export function alertConfirmDanger(options: SweetAlertOptions = {}) {
  return Swal.fire({
    ...defaultOptions,
    title: APP_TRANSLATE.instant('CONFIRMATION'),
    // html: `คุณต้องการดำเนินการต่อ?`,
    confirmButtonColor: 'var(--bs-danger)',
    iconColor: 'var(--bs-danger)',
    ...Object.assign(
      {},
      {
        ...options,
        html: options.html || options.text || APP_TRANSLATE.instant('DO_YOU_WANT_TO_CONTINUE'),
      }
    ),
  });
}

export enum alertText {
  formInvalid = 'กรุณากรอกข้อมูลให้ครบ',
  saveSuccess = 'บันทึกข้อมูลสำเร็จ',
  loginSuccess = 'เข้าสู่ระบบสำเร็จ',
  confirmDelete = 'คุณต้องการลบข้อมูล?',
  deleteSuccess = 'ลบข้อมูลสำเร็จ',
}

export function confirmDelete(text: string) {
  return `ต้องการลบ <strong>"${text}"</strong>?`;
}
